module.exports = __webpack_public_path__ + "media/images/expert__david-lemos-5a8bac29567ccf980458890077bf9e15.png";